import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from '@myplay/ui';

import I18N from '../../I18N';
import { ORANGE, BLACK, WHITE } from '../../styles/colors';

const ButtonsPanel = ({ onDiscard, onSave }) => {
  return (
    <div className="add-team-modal__buttons-panel">
      <PrimaryButton 
        background={BLACK} 
        onClick={onDiscard}
        color={WHITE}
        showBorder
      >
        {I18N.t("DISCARD").toUpperCase()}
      </PrimaryButton>
      <PrimaryButton 
        background={ORANGE} 
        onClick={onSave}
        color={WHITE}
      >
        {I18N.t("SAVE").toUpperCase()}
      </PrimaryButton>
    </div>
  );
};

ButtonsPanel.propTypes = {
  onDiscard: PropTypes.func,
  onSave: PropTypes.func
};

ButtonsPanel.defaultProps = {
  onDiscard: ()=> {},
  onSave: ()=> {}
};

export default ButtonsPanel;